var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 340,
    viewBox: "0 0 317 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_977_3040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.943 25.4417C166.943 25.9809 166.505 26.169 165.964 25.8618C165.425 25.553 164.986 24.8665 164.986 24.3257C164.986 23.785 165.424 23.5985 165.964 23.9057C166.504 24.2145 166.943 24.901 166.943 25.4417Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.854 27.6722C170.854 28.2113 170.416 28.3994 169.876 28.0922C169.336 27.7835 168.897 27.0969 168.897 26.5562C168.897 26.0155 169.335 25.8289 169.876 26.1361C170.415 26.4449 170.854 27.1314 170.854 27.6722Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.765 29.9026C174.765 30.4418 174.328 30.6299 173.787 30.3227C173.248 30.0139 172.809 29.3274 172.809 28.7867C172.809 28.2459 173.246 28.0594 173.787 28.3666C174.326 28.6754 174.765 29.3619 174.765 29.9026Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.491 0.637364L282.982 81.4556C286.489 83.501 288.644 87.2565 288.644 91.3144V231.208C288.644 234.501 285.07 236.553 282.227 234.893L141.746 152.915C139.149 151.399 137.553 148.619 137.553 145.613V4.62005C137.553 1.05899 141.415 -1.15884 144.491 0.635796V0.637364Z",
    fill: "url(#paint0_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.875 2.88189L277.366 83.7002C280.873 85.7456 283.028 89.501 283.028 93.5589V233.453C283.028 236.746 279.454 238.798 276.61 237.138L136.13 155.16C133.532 153.644 131.937 150.863 131.937 147.857V6.86614C131.937 3.30508 135.799 1.08725 138.875 2.88189Z",
    fill: "#2D2F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.96 150.312C138.092 149.805 137.553 148.865 137.553 147.86V22.9127C137.553 19.5632 141.188 17.4755 144.082 19.1651L274.535 95.2922C276.309 96.3282 277.411 98.2467 277.411 100.302V231.106L138.96 150.312Z",
    fill: "#FFFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.714 68.2305L313.414 119.41C315.634 120.706 316.999 123.082 316.999 125.653V214.242C316.999 216.328 314.735 217.627 312.934 216.576L223.974 164.661C222.329 163.702 221.318 161.94 221.318 160.038V70.7539C221.318 68.5001 223.765 67.0941 225.712 68.2305H225.714Z",
    fill: "url(#paint1_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.455 69.8609L310.155 121.04C312.375 122.336 313.74 124.713 313.74 127.283V215.872C313.74 217.959 311.477 219.258 309.675 218.206L220.715 166.292C219.071 165.333 218.06 163.571 218.06 161.668V72.3828C218.06 70.129 220.507 68.723 222.453 69.8594L222.455 69.8609Z",
    fill: "#2D2F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.027 127.281V215.849L222.088 163.944C221.279 163.477 220.779 162.603 220.779 161.669V72.3835C220.779 72.1828 220.986 72.1719 220.986 72.1719C221.008 72.1719 221.041 72.1766 221.09 72.2048L308.79 123.383C310.169 124.191 311.027 125.685 311.027 127.281V127.281Z",
    fill: "url(#paint2_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.027 127.281V136.658L220.779 83.6403V72.3835C220.779 72.1828 220.986 72.1719 220.986 72.1719C221.008 72.1719 221.041 72.1766 221.09 72.2048L308.79 123.383C310.169 124.191 311.027 125.685 311.027 127.281Z",
    fill: "url(#paint3_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.61 133.513L225.365 113.465C224.899 113.192 224.519 112.589 224.519 112.125C224.519 111.659 224.899 111.502 225.365 111.774L259.61 131.822C260.076 132.095 260.457 132.698 260.457 133.162C260.457 133.627 260.076 133.784 259.61 133.513Z",
    fill: "#868E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.61 127.474L225.365 107.426C224.899 107.153 224.519 106.55 224.519 106.086C224.519 105.62 224.899 105.463 225.365 105.735L259.61 125.783C260.076 126.055 260.457 126.659 260.457 127.123C260.457 127.588 260.076 127.745 259.61 127.474Z",
    fill: "#868E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.61 138.415L225.365 118.367C224.899 118.094 224.519 117.491 224.519 117.027C224.519 116.561 224.899 116.405 225.365 116.676L259.61 136.724C260.076 136.997 260.457 137.6 260.457 138.064C260.457 138.53 260.076 138.686 259.61 138.415Z",
    fill: "#868E8E"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.248 185.572L268.003 165.523C267.537 165.251 267.156 164.647 267.156 164.183C267.156 163.718 267.537 163.561 268.003 163.832L302.248 183.88C302.714 184.153 303.095 184.757 303.095 185.22C303.095 185.686 302.714 185.843 302.248 185.572Z",
    fill: "#868E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.248 179.536L268.003 159.488C267.537 159.215 267.156 158.612 267.156 158.148C267.156 157.683 267.537 157.526 268.003 157.797L302.248 177.845C302.714 178.118 303.095 178.721 303.095 179.185C303.095 179.651 302.714 179.808 302.248 179.536Z",
    fill: "#868E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.248 190.478L268.003 170.43C267.537 170.157 267.156 169.553 267.156 169.089C267.156 168.624 267.537 168.467 268.003 168.738L302.248 188.787C302.714 189.059 303.095 189.663 303.095 190.127C303.095 190.592 302.714 190.749 302.248 190.478Z",
    fill: "#868E8E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.099 158.423L227.489 147.263C225.854 146.334 224.517 144.235 224.517 142.6C224.517 140.965 225.854 140.39 227.489 141.32L247.099 152.479C248.734 153.409 250.071 155.508 250.071 157.142C250.071 158.777 248.734 159.352 247.099 158.423Z",
    fill: "url(#paint4_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.477 170.542L267.156 148.497V118.566L305.477 140.611V170.542Z",
    fill: "#FCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.489 146.742V123.012L303.145 142.373V166.103L269.489 146.742Z",
    fill: "#DADBE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.489 140.875L276.711 136.445L284.602 149.364L293.911 141.028L303.145 157.791V166.102L269.489 146.74V140.875Z",
    fill: "#2D2F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.159 111.946L254.548 100.787C252.913 99.8572 251.576 97.7585 251.576 96.1237C251.576 94.4889 252.913 93.9137 254.548 94.8431L274.159 106.003C275.794 106.932 277.131 109.031 277.131 110.666C277.131 112.3 275.794 112.876 274.159 111.946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.687 16.1563L204.267 57.2872C206.487 58.5834 207.852 60.9595 207.852 63.53V152.121C207.852 154.207 205.589 155.506 203.788 154.455L131.948 112.589C130.304 111.629 129.293 109.868 129.293 107.965V18.6797C129.293 16.4258 131.74 15.0199 133.687 16.1563V16.1563Z",
    fill: "url(#paint5_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.428 17.7867L201.009 58.9176C203.228 60.2138 204.594 62.59 204.594 65.1605V153.75C204.594 155.836 202.33 157.135 200.529 156.084L128.69 114.218C127.045 113.258 126.034 111.497 126.034 109.594V20.3086C126.034 18.0548 128.481 16.6488 130.428 17.7852V17.7867Z",
    fill: "#2D2F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.879 76.3626V153.728L130.06 111.87C129.251 111.403 128.751 110.528 128.751 109.594V31.5124C128.751 31.3118 128.958 31.3008 128.958 31.3008C128.98 31.3008 129.013 31.3055 129.061 31.3337L199.642 72.4646C201.021 73.2734 201.879 74.7671 201.879 76.3626V76.3626Z",
    fill: "url(#paint6_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.428 65.1283L151.926 66.1205C152.195 65.2396 152.556 64.4559 152.998 63.7804L150.82 57.7256L151.661 56.9529C152.093 56.5517 152.601 56.2617 153.169 56.0924L154.263 55.7617L158.419 60.688C159.229 60.6503 160.091 60.735 160.991 60.9481L162.4 56.5862L163.764 57.1661C164.117 57.3165 164.473 57.4937 164.827 57.699C165.181 57.9043 165.537 58.1363 165.888 58.3949L167.252 59.3917L168.63 65.365C169.53 66.1926 170.387 67.1016 171.196 68.075L175.364 67.9606L176.455 69.5546C177.02 70.3774 177.523 71.252 177.952 72.1517L178.785 73.8915L176.581 77.4134C177.018 78.5983 177.372 79.7942 177.636 80.9823L182.124 85.1828L182.301 86.8568C182.393 87.7235 182.39 88.5448 182.294 89.3018L182.108 90.7658L177.611 89.7721C177.341 90.6545 176.98 91.4366 176.538 92.1137L178.716 98.1669L177.875 98.9412C177.441 99.3408 176.935 99.6308 176.369 99.8017L175.273 100.131L171.119 95.2046C170.307 95.2422 169.447 95.156 168.545 94.9428L167.137 99.3064L165.772 98.7264C165.419 98.5775 165.065 98.3989 164.709 98.1935C164.355 97.9882 163.999 97.7562 163.646 97.4976L162.284 96.5008L160.905 90.526C160.007 89.7 159.147 88.7909 158.34 87.8176L154.17 87.932L153.081 86.3395C152.517 85.5151 152.012 84.6421 151.584 83.7424L150.752 82.001L152.956 78.4807C152.518 77.2942 152.164 76.0983 151.899 74.9087L147.411 70.7097L147.235 69.0358C147.143 68.1706 147.146 67.3493 147.242 66.5907L147.427 65.1267L147.428 65.1283ZM164.736 89.4649C170.263 92.6592 174.759 90.0918 174.776 83.733C174.794 77.371 170.328 69.6251 164.802 66.4308C159.273 63.2349 154.777 65.7992 154.76 72.1611C154.743 78.5199 159.209 86.269 164.738 89.4649",
    fill: "#2D2F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.018 132.516L136.491 101.825C135.19 101.079 134.124 99.4036 134.124 98.1011V96.4271C134.124 95.1262 135.188 94.6717 136.491 95.4177L190.018 126.108C191.319 126.854 192.385 128.53 192.385 129.832V131.506C192.385 132.807 191.32 133.262 190.018 132.516V132.516Z",
    fill: "url(#paint7_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.946 101.748L136.432 100.306V96.957L138.946 98.3974V101.748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.932 104.034L140.418 102.593V99.2422L142.932 100.683V104.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.917 106.319L144.404 104.878V101.527L146.917 102.969V106.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.903 108.604L148.391 107.164V103.812L150.903 105.254V108.604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.89 110.889L152.377 109.447V106.098L154.89 107.538V110.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.876 113.174L156.363 111.732V108.383L158.876 109.823V113.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.862 115.459L160.35 114.019V110.668L162.862 112.108V115.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.364 289.668V332.507C184.389 332.479 182.426 331.952 180.678 330.93L115.222 292.53C113.587 291.577 112.763 289.958 112.678 288.295H112.664V286.5L186.364 289.669V289.668Z",
    fill: "#BEC2CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M180.677 338.425L115.229 300.026C111.76 297.992 111.794 292.965 115.29 290.978L171.889 258.796C174.571 257.271 177.865 257.293 180.527 258.854L249.475 299.307C252.019 300.799 251.994 304.485 249.43 305.943L192.164 338.503C188.596 340.532 184.217 340.502 180.677 338.425Z",
    fill: "#2D2F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.364 292.467V294.674H251.307C251.478 296.124 250.867 297.63 249.431 298.455L192.162 331.015C190.357 332.039 188.353 332.536 186.362 332.507V289.668L251.364 292.467V292.467Z",
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.677 328.23L115.229 289.831C111.76 287.796 111.794 282.77 115.29 280.782L171.889 248.601C174.571 247.076 177.865 247.098 180.527 248.659L249.475 289.111C252.019 290.604 251.994 294.29 249.43 295.748L192.164 328.308C188.596 330.336 184.217 330.307 180.677 328.23Z",
    fill: "url(#paint8_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.488 327.644C184.831 327.644 183.201 327.2 181.773 326.363L116.325 287.964C115.372 287.405 114.806 286.411 114.814 285.305C114.821 284.2 115.4 283.212 116.361 282.667L166.774 253.487C167.748 252.934 168.853 252.641 169.972 252.641C171.091 252.641 172.255 252.948 173.245 253.531L242.194 293.983C242.943 294.422 243.018 295.141 243.017 295.431C243.015 295.72 242.929 296.439 242.175 296.869L191.095 326.428C189.694 327.224 188.101 327.646 186.49 327.646L186.488 327.644Z",
    fill: "url(#paint9_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.773 278.859L159.755 268.569C159.496 268.43 159.646 268.12 160.087 267.881C160.529 267.643 161.101 267.562 161.36 267.701L180.378 277.991C180.636 278.13 180.486 278.441 180.045 278.679C179.603 278.917 179.031 278.999 178.773 278.859V278.859Z",
    fill: "#868E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.502 275.761L165.484 265.472C165.225 265.332 165.376 265.022 165.816 264.784C166.258 264.545 166.831 264.464 167.089 264.603L186.107 274.893C186.366 275.033 186.215 275.343 185.775 275.581C185.333 275.819 184.761 275.901 184.502 275.761Z",
    fill: "#868E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.115 281.379L155.097 271.089C154.839 270.949 154.989 270.639 155.43 270.401C155.872 270.163 156.444 270.081 156.703 270.221L175.721 280.51C175.979 280.65 175.829 280.96 175.388 281.198C174.946 281.437 174.374 281.518 174.115 281.379V281.379Z",
    fill: "#868E8E"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.454 309.48L163.436 299.19C163.178 299.051 163.328 298.741 163.769 298.502C164.211 298.264 164.783 298.183 165.041 298.322L184.059 308.612C184.318 308.751 184.168 309.062 183.727 309.3C183.285 309.538 182.713 309.62 182.454 309.48Z",
    fill: "#868E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.185 306.383L169.167 296.093C168.908 295.953 169.059 295.643 169.499 295.405C169.941 295.166 170.513 295.085 170.772 295.224L189.79 305.514C190.049 305.654 189.898 305.964 189.458 306.202C189.015 306.441 188.443 306.522 188.185 306.383Z",
    fill: "#868E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.797 312L158.781 301.71C158.522 301.57 158.673 301.26 159.113 301.022C159.555 300.784 160.128 300.702 160.386 300.842L179.404 311.131C179.663 311.271 179.512 311.581 179.072 311.82C178.63 312.058 178.058 312.139 177.799 312H177.797Z",
    fill: "#868E8E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.225 291.647L130.031 285.919C129.099 285.441 129.605 284.365 131.155 283.526C132.707 282.688 134.739 282.391 135.671 282.869L146.866 288.597C147.798 289.075 147.292 290.151 145.742 290.99C144.19 291.828 142.158 292.125 141.225 291.647Z",
    fill: "url(#paint10_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.4 304.4L175.75 293.085L200.998 279.352L222.646 290.666L197.4 304.4Z",
    fill: "#FCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.011 292.183L199.372 281.633L218.387 291.57L199.026 302.12L180.011 292.183Z",
    fill: "#DADBE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.579 289.171L197.806 286.898L194.31 293.528L212.566 289.251L206.914 297.854L199.026 302.119L180.011 292.182L185.579 289.171Z",
    fill: "#2D2F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.364 282.082V324.921C184.389 324.893 182.426 324.366 180.678 323.344L115.222 284.944C113.587 283.991 112.763 282.372 112.678 280.709H112.664V278.914L186.364 282.083V282.082Z",
    fill: "#BEC2CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.364 284.881V287.088H251.307C251.478 288.538 250.867 290.044 249.431 290.869L192.162 323.429C190.357 324.453 188.353 324.95 186.362 324.921V282.082L251.364 284.881V284.881Z",
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.677 320.644L115.229 282.245C111.76 280.21 111.794 275.184 115.29 273.196L171.889 241.015C174.571 239.49 177.865 239.512 180.527 241.073L249.475 281.525C252.019 283.018 251.994 286.704 249.43 288.162L192.164 320.722C188.596 322.75 184.217 322.721 180.677 320.644V320.644Z",
    fill: "url(#paint11_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.488 320.058C184.831 320.058 183.201 319.614 181.773 318.777L116.325 280.378C115.372 279.819 114.806 278.825 114.814 277.719C114.821 276.614 115.4 275.626 116.361 275.081L166.774 245.901C167.748 245.348 168.853 245.055 169.972 245.055C171.091 245.055 172.255 245.362 173.245 245.945L242.194 286.397C242.943 286.836 243.018 287.555 243.017 287.845C243.015 288.134 242.929 288.853 242.175 289.283L191.095 318.842C189.694 319.638 188.101 320.06 186.49 320.06L186.488 320.058Z",
    fill: "url(#paint12_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.773 271.273L159.755 260.983C159.496 260.844 159.646 260.534 160.087 260.295C160.529 260.057 161.101 259.976 161.36 260.115L180.378 270.405C180.636 270.544 180.486 270.855 180.045 271.093C179.603 271.331 179.031 271.413 178.773 271.273V271.273Z",
    fill: "#868E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.502 268.176L165.484 257.886C165.225 257.746 165.376 257.436 165.816 257.198C166.258 256.959 166.831 256.878 167.089 257.017L186.107 267.307C186.366 267.447 186.215 267.757 185.775 267.995C185.333 268.234 184.761 268.315 184.502 268.176Z",
    fill: "#868E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.115 273.793L155.097 263.503C154.839 263.363 154.989 263.053 155.43 262.815C155.872 262.577 156.444 262.495 156.703 262.635L175.721 272.924C175.979 273.064 175.829 273.374 175.388 273.612C174.946 273.851 174.374 273.932 174.115 273.793V273.793Z",
    fill: "#868E8E"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.454 301.894L163.436 291.604C163.178 291.465 163.328 291.155 163.769 290.916C164.211 290.678 164.783 290.597 165.041 290.736L184.059 301.026C184.318 301.165 184.168 301.476 183.727 301.714C183.285 301.952 182.713 302.034 182.454 301.894Z",
    fill: "#868E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.184 298.797L169.166 288.507C168.907 288.367 169.058 288.057 169.498 287.819C169.94 287.581 170.512 287.499 170.771 287.639L189.789 297.928C190.048 298.068 189.897 298.378 189.457 298.616C189.014 298.855 188.442 298.936 188.184 298.797Z",
    fill: "#868E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.797 304.414L158.781 294.124C158.522 293.985 158.673 293.674 159.113 293.436C159.555 293.198 160.128 293.116 160.386 293.256L179.404 303.545C179.663 303.685 179.512 303.995 179.072 304.234C178.63 304.472 178.058 304.553 177.799 304.414H177.797Z",
    fill: "#868E8E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.225 284.061L130.031 278.334C129.099 277.855 129.605 276.779 131.155 275.94C132.707 275.102 134.739 274.805 135.671 275.283L146.866 281.011C147.798 281.489 147.292 282.565 145.742 283.404C144.19 284.242 142.158 284.539 141.225 284.061Z",
    fill: "url(#paint13_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.4 296.814L175.75 285.497L200.998 271.766L222.646 283.08L197.4 296.814Z",
    fill: "#FCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.011 284.594L199.372 274.043L218.387 283.982L199.026 294.532L180.011 284.594Z",
    fill: "#DADBE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.579 281.585L197.806 279.312L194.31 285.942L212.566 281.664L206.914 290.268L199.026 294.533L180.011 284.596L185.579 281.585Z",
    fill: "#2D2F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.077 156.832L192.135 173.64L193.918 185.175C207.535 192.972 220.852 200.529 220.852 200.529V237.106C220.852 237.106 163.997 204.845 165.093 204.845C165.099 204.845 165.104 204.83 165.11 204.828L165.077 204.845V156.832V156.832Z",
    fill: "url(#paint14_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.296 159.355L188.354 176.164L190.136 187.698C203.754 195.496 217.071 203.052 217.071 203.052V239.63C217.071 239.63 160.216 207.369 161.312 207.369C161.318 207.369 161.323 207.353 161.329 207.351L161.296 207.369V159.355V159.355Z",
    fill: "url(#paint15_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.077 156.832L161.296 159.354L188.354 176.162L192.135 173.64L165.077 156.832Z",
    fill: "url(#paint16_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.852 200.53L217.071 203.052L190.137 187.698L193.918 185.176L220.852 200.53Z",
    fill: "url(#paint17_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.851 237.107L217.07 239.627V203.049L220.851 200.527V237.107Z",
    fill: "url(#paint18_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.852 233.461L208.452 241.343V244.989L220.852 237.107V233.461Z",
    fill: "url(#paint19_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.464 126.416L162.66 126.815L163.464 191.101C169.779 199.659 191.585 221.409 191.585 221.409L214.1 234.895V156.84L163.464 126.414V126.416Z",
    fill: "url(#paint20_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.071 235.864L212.233 233.461V238.939L217.071 235.864Z",
    fill: "url(#paint21_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66 126.818V191.503C168.974 200.061 190.781 221.812 190.781 221.812L213.296 235.297V157.242L162.66 126.816V126.818Z",
    fill: "url(#paint22_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.163 156.327L204.421 167.77C204.99 168.107 205.454 167.919 205.454 167.352C205.454 166.783 204.988 166.041 204.421 165.704L185.163 154.261C184.594 153.924 184.13 154.112 184.13 154.68C184.13 155.249 184.595 155.99 185.163 156.327Z",
    fill: "url(#paint23_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.227 158.182L204.421 176.751C204.99 177.088 205.454 176.9 205.454 176.333C205.454 175.764 204.988 175.022 204.421 174.685L173.227 156.117C172.658 155.78 172.194 155.968 172.194 156.535C172.194 157.104 172.66 157.845 173.227 158.182V158.182Z",
    fill: "url(#paint24_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.227 163.249L204.421 181.817C204.99 182.154 205.454 181.966 205.454 181.399C205.454 180.83 204.988 180.089 204.421 179.752L173.227 161.183C172.658 160.846 172.194 161.034 172.194 161.601C172.194 162.17 172.66 162.912 173.227 163.249Z",
    fill: "url(#paint25_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.227 168.319L204.421 186.888C204.99 187.225 205.454 187.037 205.454 186.469C205.454 185.9 204.988 185.159 204.421 184.822L173.227 166.253C172.658 165.916 172.194 166.104 172.194 166.672C172.194 167.241 172.66 167.982 173.227 168.319Z",
    fill: "url(#paint26_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.227 173.386L204.421 191.954C204.99 192.291 205.454 192.103 205.454 191.536C205.454 190.967 204.988 190.225 204.421 189.888L173.227 171.32C172.658 170.983 172.194 171.171 172.194 171.738C172.194 172.307 172.66 173.049 173.227 173.386Z",
    fill: "url(#paint27_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.227 178.452L204.421 197.021C204.99 197.358 205.454 197.169 205.454 196.602C205.454 196.033 204.988 195.292 204.421 194.955L173.227 176.386C172.658 176.049 172.194 176.237 172.194 176.805C172.194 177.374 172.66 178.115 173.227 178.452Z",
    fill: "url(#paint28_linear_977_3040)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.459 162.191L183.517 179L185.299 190.534C198.917 198.332 212.234 205.888 212.234 205.888V242.466C212.234 242.466 155.379 210.205 156.475 210.205C156.481 210.205 156.486 210.189 156.492 210.187L156.459 210.205V162.191V162.191Z",
    fill: "url(#paint29_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.678 164.711L179.736 181.519L181.518 193.054C195.136 200.851 208.452 208.408 208.452 208.408V244.985C208.452 244.985 151.598 212.724 152.693 212.724C152.7 212.724 152.704 212.708 152.711 212.707L152.678 212.724V164.711V164.711Z",
    fill: "url(#paint30_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.459 162.191L152.678 164.712L179.736 181.52L183.517 179L156.459 162.191Z",
    fill: "url(#paint31_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.234 205.889L208.453 208.409L181.519 193.055L185.3 190.535L212.234 205.889Z",
    fill: "url(#paint32_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.233 242.464L208.452 244.986V208.407L212.233 205.887V242.464Z",
    fill: "url(#paint33_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M76.1028 280.04L2.88724 237.085C-0.992536 234.809 -0.954914 229.187 2.95621 226.963L66.2709 190.962C69.2729 189.255 72.9567 189.28 75.9335 191.028L153.063 236.279C155.909 237.949 155.88 242.072 153.013 243.702L88.9523 280.126C84.9612 282.396 80.061 282.363 76.1013 280.039L76.1028 280.04Z",
    fill: "#2D2F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4641 223.37V271.292C80.2538 271.261 78.0592 270.671 76.1044 269.527L2.88096 226.57C1.05159 225.504 0.129853 223.692 0.0342305 221.832H0.0185547V219.824L82.4641 223.37V223.37Z",
    fill: "#BEC2CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.178 226.503V228.971H155.115C155.306 230.594 154.623 232.278 153.016 233.2L88.9521 269.624C86.9331 270.768 84.6914 271.325 82.4639 271.293V223.371L155.178 226.503V226.503Z",
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1028 266.509L2.88724 223.554C-0.992536 221.278 -0.954914 215.656 2.95621 213.432L66.2709 177.431C69.2729 175.724 72.9567 175.749 75.9335 177.497L153.063 222.748C155.909 224.417 155.88 228.541 153.013 230.171L88.9523 266.595C84.9612 268.865 80.061 268.832 76.1013 266.507L76.1028 266.509Z",
    fill: "url(#paint34_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M77.6889 244.392C94.9529 244.392 108.948 237.465 108.948 228.921C108.948 220.376 94.9529 213.449 77.6889 213.449C60.4249 213.449 46.4297 220.376 46.4297 228.921C46.4297 237.465 60.4249 244.392 77.6889 244.392Z",
    fill: "#2D2F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4134 169.056C55.4134 169.056 54.2925 173.176 54.5904 174.861C54.8882 176.546 56.4495 180.309 57.9968 179.914C59.544 179.52 61.3279 178.825 61.4266 176.349C61.5254 173.872 60.4249 167.457 60.4249 167.457L55.4134 169.059V169.056Z",
    fill: "#FFBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8105 231.969C73.8105 231.969 73.6898 234.575 73.8105 235.143C73.9312 235.712 77.9129 238.245 79.8253 237.21C81.7378 236.176 93.3175 230.129 93.421 228.63C93.5244 227.132 91.7672 224.858 89.5961 225.011C87.425 225.166 78.7405 228.086 78.7405 228.086L73.8121 231.967L73.8105 231.969Z",
    fill: "#1D2035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4512 221.658C59.4512 221.658 58.6298 225.685 58.9402 225.995C59.2506 226.306 62.6099 228.528 63.6962 228.011C64.7826 227.494 72.6393 220.257 72.6393 218.759C72.6393 217.26 70.6751 215.915 68.0902 217.26C65.5052 218.604 59.4512 221.66 59.4512 221.66V221.658Z",
    fill: "#1D2035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5847 164.102C61.5847 164.102 58.3006 170.848 59.8651 176.277C61.4295 181.706 61.4295 182.35 61.4295 182.35V196.704C61.4295 196.704 59.2208 201.029 58.7615 207.286C58.3006 213.543 58.7615 220.812 58.7615 220.812C58.7615 220.812 59.7741 222.652 62.0738 222.837C64.375 223.021 66.6746 221.09 66.6746 221.09C66.6746 221.09 67.4114 205.816 69.711 199.559C72.0123 193.302 74.8637 171.678 74.8637 171.678L61.5831 164.105L61.5847 164.102Z",
    fill: "#1D2035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7549 167.469C65.7549 167.469 66.2048 178.27 68.7223 181.93C71.2383 185.589 73.1837 187.191 73.1837 187.191L74.8657 202.288C74.8657 202.288 73.1837 209.379 73.1837 216.126V230.88C73.1837 230.88 73.9847 233.51 77.4161 233.51C80.8476 233.51 83.0203 230.537 83.0203 230.537C83.0203 230.537 82.3336 209.379 84.8512 202.86C87.3672 196.342 85.356 165.883 85.356 165.883C85.356 165.883 76.2122 171.417 65.7549 167.469V167.469Z",
    fill: "#2D2F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8005 124.914C57.8005 124.914 52.2998 148.802 52.6713 151.791C53.0428 154.78 54.0398 170.36 54.0398 170.36C54.0398 170.36 56.0322 171.573 58.4526 171.147C60.8729 170.72 61.5846 168.3 61.5846 168.3V145.912L57.802 124.914H57.8005Z",
    fill: "url(#paint35_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1609 113.349C81.1609 113.349 81.7864 113.992 81.6202 115.551C81.4541 117.111 80.5825 120.402 79.6467 120.995C78.7124 121.587 76.7121 121.492 76.7121 121.492L75.7136 128.929L65.6826 121.399L67.5935 113.177C67.5935 113.177 76.8971 110.807 77.0429 110.809C77.1887 110.81 81.1594 113.349 81.1594 113.349H81.1609Z",
    fill: "#FFBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5308 106.218C85.1377 110.762 82.8725 113.743 80.1857 114.975C77.4988 116.205 76.9314 116.62 76.9314 116.62C76.9314 116.62 77.9503 113.892 75.7808 113.161C73.6112 112.431 75.4516 116.87 73.9608 117.981C72.47 119.094 69.7205 119.677 67.3534 117.896C64.9864 116.116 63.4815 107.31 66.6825 104.469C69.8835 101.627 79.0774 100.199 82.5308 106.218V106.218Z",
    fill: "#1D2035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8949 122.659C66.8949 122.659 75.1075 124.43 75.8192 126.013C76.5309 127.596 86.3518 133.574 86.3518 133.574L85.3548 165.88C85.3548 165.88 78.807 171.004 71.1211 170.293C63.4353 169.581 59.8267 165.578 59.8267 165.578C59.8267 165.578 60.0179 146.953 58.8799 142.114C57.7418 137.276 55.4641 129.513 57.1712 125.922C58.8799 122.331 66.8934 122.66 66.8934 122.66L66.8949 122.659Z",
    fill: "url(#paint36_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4978 104.153C69.4978 104.153 71.2989 104.598 71.3773 107.551C71.4557 110.504 68.841 111.525 68.841 111.525L67.6465 111.51C67.6465 111.51 69.5401 117.369 68.0634 122.901C66.5868 128.434 55.9727 128.299 55.9727 128.299C55.9727 128.299 61.1457 125.132 61.1457 119.649C61.1457 114.167 59.6816 107.681 62.3214 104.692C64.9612 101.703 69.4993 104.151 69.4993 104.151L69.4978 104.153Z",
    fill: "#1D2035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7693 128.075C69.249 127.469 106.843 106.214 106.843 106.214C106.843 106.214 109.489 93.9648 118.374 90.4821C127.259 86.9994 132.424 94.9256 132.424 94.9256L122.853 100.093C122.164 100.465 121.735 101.184 121.735 101.966V108.14C121.735 109.505 123.183 110.385 124.393 109.754L133.025 105.269C133.025 105.269 132.664 114.526 124.618 117.814C116.571 121.102 110.878 119.195 110.878 119.195L72.1318 139.956C72.1318 139.956 72.4563 149.443 61.0051 152.926C49.5523 156.409 48.1979 150.136 48.1979 150.136L55.0827 146.379C55.9621 145.9 56.5092 144.978 56.5092 143.976V138.044C56.5092 137.074 55.5169 136.419 54.625 136.801L48.0694 140.856L46.4312 140.315C46.4312 140.315 46.1914 128.318 55.5593 124.71C64.9272 121.102 68.7709 128.072 68.7709 128.072L68.7693 128.075Z",
    fill: "url(#paint37_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.661 105.807C134.661 105.807 134.3 115.064 126.255 118.352C118.206 121.64 112.515 119.736 112.515 119.736L105.69 123.393L96.8161 128.148L86.1628 133.858L79.3658 137.499L73.7695 140.499C73.7695 140.499 74.094 149.986 62.6428 153.467C51.1916 156.952 49.8372 150.679 49.8372 150.679L56.7204 146.921C57.5999 146.439 58.1485 145.521 58.1485 144.519V138.587C58.1485 137.614 57.1547 136.96 56.2627 137.344L48.0689 140.86C48.0689 140.86 47.826 128.861 57.197 125.252C66.5649 121.642 70.4086 128.615 70.4086 128.615C70.8851 128.009 108.481 106.755 108.481 106.755C108.481 106.755 111.125 94.5077 120.01 91.0219C128.897 87.5376 134.063 95.4638 134.063 95.4638L124.489 100.633C123.801 101.004 123.374 101.724 123.374 102.506V108.677C123.374 110.045 124.821 110.921 126.034 110.291L134.662 105.805L134.661 105.807Z",
    fill: "url(#paint38_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9989 131.469L108.233 111.8C109.003 111.358 109.962 111.913 109.962 112.8V113.071C109.962 113.945 109.495 114.754 108.735 115.19L74.9583 134.597C74.035 135.128 72.8828 134.461 72.8828 133.396C72.8828 132.6 73.3092 131.865 73.9989 131.469V131.469Z",
    fill: "url(#paint39_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.724 121.462C98.1657 121.763 97.5936 121.462 97.5936 121.462C97.5936 121.462 97.2957 124.509 96.8145 128.15C96.1028 133.551 94.9992 140.266 93.8925 140.266C92.4613 140.266 88.0689 135.851 86.1596 133.86L79.3626 137.501C78.9487 139.058 79.2967 140.951 80.9239 143.112C85.2112 148.802 97.4525 155.493 100.014 152.932C102.028 150.918 104.657 131.577 105.689 123.395C105.971 121.169 106.134 119.77 106.134 119.77C106.134 119.77 105.281 121.166 101.723 121.462H101.724Z",
    fill: "url(#paint40_linear_977_3040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4909 121.584C98.4909 121.584 96.37 119.949 96.3214 117.841C96.2728 115.733 96.3214 115.021 96.3214 115.021C96.3214 115.021 97.5347 113.503 98.157 115.349C98.7794 117.195 100.341 117.341 100.637 114.434C100.933 111.526 98.2887 107.547 99.9927 106.76C101.697 105.973 104.517 108.268 105.108 112.006C105.697 115.742 105.584 120.296 105.584 120.296C105.584 120.296 102.496 123.162 98.4909 121.584Z",
    fill: "#FFBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_977_3040",
    x1: 207.235,
    y1: 105.38,
    x2: 228.419,
    y2: 151.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAC9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AAA9AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7879"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_977_3040",
    x1: 264.816,
    y1: 133.32,
    x2: 274.733,
    y2: 154.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAC9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AAA9AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7879"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_977_3040",
    x1: 248.855,
    y1: 195.054,
    x2: 277.881,
    y2: 108.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADBE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_977_3040",
    x1: 220.779,
    y1: 104.414,
    x2: 311.027,
    y2: 104.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A84CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_977_3040",
    x1: 224.518,
    y1: 149.871,
    x2: 250.071,
    y2: 149.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A84CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_977_3040",
    x1: 160.057,
    y1: 62.4328,
    x2: 173.46,
    y2: 98.8738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAC9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AAA9AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7879"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_977_3040",
    x1: 159.364,
    y1: 126.279,
    x2: 170.974,
    y2: 60.5818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADBE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_977_3040",
    x1: 134.124,
    y1: 113.968,
    x2: 192.385,
    y2: 113.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A84CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_977_3040",
    x1: 182.008,
    y1: 238.072,
    x2: 182.008,
    y2: 317.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A84CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_977_3040",
    x1: 178.915,
    y1: 244.077,
    x2: 178.915,
    y2: 316.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_977_3040",
    x1: 129.563,
    y1: 287.258,
    x2: 147.334,
    y2: 287.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A84CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_977_3040",
    x1: 182.008,
    y1: 230.484,
    x2: 182.008,
    y2: 310.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A84CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_977_3040",
    x1: 0.000554952,
    y1: 236.492,
    x2: 0.15727,
    y2: 309.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_977_3040",
    x1: 129.563,
    y1: 279.67,
    x2: 147.334,
    y2: 279.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A84CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_977_3040",
    x1: 220.853,
    y1: 196.971,
    x2: 165.079,
    y2: 196.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B78248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBD4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_977_3040",
    x1: 217.071,
    y1: 199.493,
    x2: 161.296,
    y2: 199.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B78248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5A563"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_977_3040",
    x1: 192.137,
    y1: 166.496,
    x2: 161.296,
    y2: 166.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B78248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBD4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_977_3040",
    x1: 220.854,
    y1: 194.113,
    x2: 190.137,
    y2: 194.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B78248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBD4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_977_3040",
    x1: 217.849,
    y1: 241.467,
    x2: 219.434,
    y2: 210.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE1AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_977_3040",
    x1: 214.545,
    y1: 241.295,
    x2: 216.13,
    y2: 210.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE1AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_977_3040",
    x1: 188.083,
    y1: 215.928,
    x2: 188.408,
    y2: 177.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A8AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_977_3040",
    x1: 217.071,
    y1: 236.199,
    x2: 212.233,
    y2: 236.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B78248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBD4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_977_3040",
    x1: 202.37,
    y1: 152.747,
    x2: 182.916,
    y2: 191.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_977_3040",
    x1: 152.131,
    y1: 136.44,
    x2: 152.482,
    y2: 135.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A4151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_977_3040",
    x1: 142.231,
    y1: 139.549,
    x2: 142.594,
    y2: 138.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A4151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_977_3040",
    x1: 140.004,
    y1: 143.295,
    x2: 140.366,
    y2: 142.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A4151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_977_3040",
    x1: 137.778,
    y1: 147.043,
    x2: 138.14,
    y2: 146.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A4151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_977_3040",
    x1: 135.551,
    y1: 150.788,
    x2: 135.913,
    y2: 150.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A4151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_977_3040",
    x1: 133.323,
    y1: 154.535,
    x2: 133.686,
    y2: 153.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A4151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_977_3040",
    x1: 212.234,
    y1: 202.329,
    x2: 156.459,
    y2: 202.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B78248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBD4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_977_3040",
    x1: 176.387,
    y1: 239.405,
    x2: 182.496,
    y2: 188.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE1AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_977_3040",
    x1: 183.518,
    y1: 171.856,
    x2: 152.678,
    y2: 171.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B78248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBD4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_977_3040",
    x1: 212.234,
    y1: 199.472,
    x2: 181.519,
    y2: 199.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B78248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5A563"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_977_3040",
    x1: 209.532,
    y1: 241.032,
    x2: 211.118,
    y2: 210.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE1AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_977_3040",
    x1: 77.5905,
    y1: 165.65,
    x2: 77.5905,
    y2: 254.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_977_3040",
    x1: 63.588,
    y1: 148.077,
    x2: 54.2138,
    y2: 148.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A84CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_977_3040",
    x1: 88.664,
    y1: 147.528,
    x2: 55.6601,
    y2: 145.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_977_3040",
    x1: 46.4297,
    y1: 121.789,
    x2: 133.025,
    y2: 121.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A6B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2D2F4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_977_3040",
    x1: 95.4476,
    y1: 130.346,
    x2: 89.5313,
    y2: 118.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADBE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_977_3040",
    x1: 72.8828,
    y1: 123.213,
    x2: 109.962,
    y2: 123.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C4CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C4E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_977_3040",
    x1: 79.2043,
    y1: 136.631,
    x2: 106.137,
    y2: 136.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A84CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABEF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_977_3040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 317,
    height: 340,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.d5ed9093063123b0e9d02c3eb9f29ea0.svg";
export { ForwardRef as ReactComponent };